import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Drawer, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/MenuRounded';
import CloseIcon from '@mui/icons-material/Close';
import logo from '../asstes/images/logo.png';
import whiteLogo from '../asstes/images/logo_white.png';
import './Navigation.css';
const items = [['About Us', '/about_us'], ['Events', '/events'], ['Gallery', '/gallery'], ['FAQs', '/faqs']];
const mobileItems = [...items.slice(0, 3), ['Blog', '/blog'], items[3], ['How it Works', '/how_its_work'], ['Origin Story', '/origin_story']];
export default function NavBar({ screen }) {
  const [open, setOpen] = useState(false);
  const [menuTop, setMenuTop] = useState(0);
  const header = useRef(null);
  const updateMenuPosition = useCallback(() => setMenuTop(Math.max(0, header.current?.getBoundingClientRect().bottom || 0)), []);
  useEffect(() => {
    if (!open) return;
    const resize = () => {
      if (window.innerWidth >= 900) setOpen(false);
      else updateMenuPosition();
    };
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [open, updateMenuPosition]);
  const { pathname } = useLocation();
  const renderLinks = entries => entries.map(([label, path]) => <Link key={path} to={path} aria-current={pathname === path ? 'page' : undefined} onClick={() => setOpen(false)}>{label}</Link>);
  return <header ref={header} className={`site-header ${screen === 'event' ? 'site-header--light' : ''}`}>
    <div className="site-nav">
      <Link className="site-brand" to="/" aria-label="Social Paws home"><picture><source media="(max-width: 899px)" srcSet={whiteLogo}/><img src={logo} alt=""/></picture><span>Social Paws</span></Link>
      <nav className="desktop-nav" aria-label="Main navigation">{renderLinks(items)}</nav>
      <IconButton className="menu-toggle" aria-label="Open navigation" aria-expanded={open} aria-controls={open ? 'mobile-navigation' : undefined} onClick={() => { updateMenuPosition(); setOpen(true); }}><MenuIcon/></IconButton>
    </div>
    <Drawer anchor="right" open={open} onClose={() => setOpen(false)}
      ModalProps={{BackdropProps:{sx:{backgroundColor:'transparent'}}}}
      PaperProps={{className:'mobile-menu-panel',sx:{width:{xs:'min(272px, calc(100vw - 48px))',sm:'360px'},top:`${menuTop}px`,bottom:'auto',height:'auto',boxShadow:'none',maxHeight:`calc(100dvh - ${menuTop}px)`,backgroundColor:'#009bce'}}}>
      <div className="drawer-header"><Link className="drawer-brand" to="/" onClick={() => setOpen(false)}>Social Paws</Link><IconButton aria-label="Close navigation" onClick={() => setOpen(false)}><CloseIcon/></IconButton></div>
      <nav id="mobile-navigation" className="mobile-nav" aria-label="Mobile navigation">{renderLinks(mobileItems)}</nav>
    </Drawer>
  </header>;
}
